import { useRef } from 'react';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { ApiClientError } from '../../../api/httpClient';

export function useCatalogFormSubmit<T extends FieldValues, TResult>(form: UseFormReturn<T>, save: (values: T) => Promise<TResult>, onSaved: (result: TResult) => void) {
  const isSaving = useRef(false);
  return form.handleSubmit(async (values) => {
    if (isSaving.current) return;
    isSaving.current = true;
    form.clearErrors();
    try {
      const savedEntity = await save(values);
      form.reset(values);
      onSaved(savedEntity);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось сохранить изменения.';
      form.setError('root', { message });
      if (error instanceof ApiClientError) {
        for (const [name, messages] of Object.entries(error.errors)) {
          if (name in values) form.setError(name as Path<T>, { message: messages.join(' ') });
        }
      }
    } finally {
      isSaving.current = false;
    }
  });
}
